import qs from 'qs';

/**
 * @description 特殊处理逻辑
 */
/**
 * 转化 spuPackId 配置
 * 通过 Apollo 上配置的 MED_SPU_PACK_ID_REVERT 进行控制
 * MED_SPU_PACK_ID_REVERT 格式为 source_sourceNumber:target_targetNumber
 * 其中 sourceNumber 可省略，默认为 1，如 76182:98524_3
 * 不省略就是 76182_1:98524_3
 */
function formatSpuPackIdRevertConfig(configString?: string) {
  const config =
    (configString || process.env.MED_SPU_PACK_ID_REVERT)
      ?.split(',')
      .map(item => item.trim())
      .filter(Boolean)
      .reduce(
        (pre, current) => {
          const [source, target] = current.split(':');

          const [sourceId, sourceNumBase = '1'] = source.split('_');
          const [targetId, targetNumBase] = target.split('_');

          if (!sourceId || !targetId || !+targetNumBase) return pre;

          pre[sourceId] = {
            spuPackId: +targetId,
            numberRatio: +targetNumBase / +sourceNumBase,
          };

          return pre;
        },
        {} as {
          [sourceSpuPackId: string]: {
            spuPackId: number;
            numberRatio: number;
          };
        }
      ) || {};

  return config;
}

/**
 * https://www.tapd.cn/20096901/prong/stories/view/1120096901001049547
 * 是否需要将 spuPackId 转化为另一个 spuPackId
 * 用于创建问诊时，详情页是药品A，创建问诊提交的药品，转为为药品B
 */
export function isNeedSpuPackRevert(sourceSpuPackId: number, sourceNumber = 1) {
  let targetSpuPackId = sourceSpuPackId;
  let targetNumber = sourceNumber;
  let needRevert = false;

  const config = formatSpuPackIdRevertConfig();

  if (config[sourceSpuPackId]) {
    needRevert = true;
    targetSpuPackId = config[sourceSpuPackId].spuPackId;
    targetNumber = sourceNumber * config[sourceSpuPackId].numberRatio;
  }

  return {
    needRevert,
    target: {
      spuPackId: targetSpuPackId,
      number: targetNumber,
    },
  };
}

/**
 * 获取 spuPack 转化后详情页的原始详情面
 */
export function getSpuPackRevertRouterConfig() {
  const config = formatSpuPackIdRevertConfig();

  const { pathname, search } = window.location;

  const urlSpuPackId = qs.parse(search, {
    ignoreQueryPrefix: true,
  }).spuPackId as string;

  if (!urlSpuPackId) return '';

  const [sourceSpuPackId, target] =
    Object.entries(config).find(([_, { spuPackId: targetSpuPackId }]) => {
      return +urlSpuPackId === +targetSpuPackId;
    }) || [];

  if (!target) return '';

  if (
    pathname.indexOf('/mall/drug-detail') > -1 &&
    search.indexOf(`spuPackId=${target.spuPackId}`) > -1
  ) {
    return window.location.href.replace(
      `spuPackId=${target.spuPackId}`,
      `spuPackId=${sourceSpuPackId}`
    );
  }

  return '';
}

// 根据白名单药品packid隐藏复购按钮
export const getMedRebuyButtonHideSkuPackIds = () =>
  process.env.MED_REBUY_BUTTON_HIDE_SKU_PACK_IDS?.split(',')
    .map(item => item.trim())
    .filter(Boolean)
    .map(item => +item) || [];
